import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AuthBarComponent } from './auth-bar/auth-bar.component';
import { YmdPickerComponent } from './ymd-picker/ymd-picker.component';
import { ExpandItemComponent } from './expand-item/expand-item.component';
import { PileEditorComponent } from './pile-editor/pile-editor.component';
import { ExpandListComponent } from './expand-list/expand-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RoadInputComponent } from './road-input/road-input.component';
import { SectorEditorComponent } from './sector-editor/sector-editor.component';
import { VolumePieChartComponent } from './charts/volume-pie-chart/volume-pie-chart.component';
import { LeafletMapComponent } from './maps/leaflet-map/leaflet-map.component';
import { SectorTimelineComponent } from './charts/sector-timeline/sector-timeline.component';
import { TransportGaugeComponent } from './charts/transport-gauge/transport-gauge.component';
import { TransportVolumeComponent } from './charts/transport-volume/transport-volume.component';
import { ConflictMediatorComponent } from './conflict-mediator/conflict-mediator.component';
import { StringSelectorComponent } from './string-selector/string-selector.component';
import { TableCellComponent } from './table-cell/table-cell.component';
import { HeaderRowComponent } from './report/header-row/header-row.component';
import { EditableRowComponent } from './report/editable-row/editable-row.component';
import { RoadinfoEditorComponent } from './roadinfo-editor/roadinfo-editor.component';


const COMPONENTS:any[] = [
  AuthBarComponent,
  YmdPickerComponent,
  ExpandItemComponent,
  PileEditorComponent,
  SectorEditorComponent,
  ExpandListComponent,
  RoadInputComponent,
  VolumePieChartComponent,
  LeafletMapComponent,
  SectorTimelineComponent,
  TransportGaugeComponent,
    TransportVolumeComponent,
    ConflictMediatorComponent,
    StringSelectorComponent,
    TableCellComponent,
    HeaderRowComponent,
    EditableRowComponent,
    RoadinfoEditorComponent
]

@NgModule({
  imports: [
    CommonModule,
    IonicModule,   FormsModule, ReactiveFormsModule

  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class ComponentsModule { }
